import React, { useState, useContext } from "react";
import NavMenu from "../ui/NavMenu/NavMenu.js";
import SimpleConfirmModal from "../ui/Modal/SimpleConfirmModal";
import ModerationCountContext from "../context/ModerationCountContext";
import { setToken } from "../utils/token";
import * as api from "../utils/api";
import { useTimeTrackingContext } from "../context/TimeTrackingContext";

const NavMenuComponent = () => {
  const [showLogout, setShowLogout] = useState(false);
  const moderationCountContext = useContext(ModerationCountContext);
  const { stopSession } = useTimeTrackingContext();

  const logout = async () => {
    try {
      await api.logout();
      await stopSession();
      setToken(null);
      window.location = "/";
    } catch {
      alert("Не удалось выйти из кабинета");
    }
  };

  return (
    <React.Fragment>
      <NavMenu
        onLogoutClick={() => {
          setShowLogout(true);
        }}
        moderationCount={moderationCountContext.count.total}
      />

      {showLogout && (
        <SimpleConfirmModal
          title="Вы уверены что хотите выйти?"
          onCancel={() => {
            setShowLogout(false);
          }}
          onConfirm={logout}
        />
      )}
    </React.Fragment>
  );
};

export default NavMenuComponent;
